import $ from 'jquery';
import ApplicationController from '@aha-app/mvc';
import {
  AhaEditorUtils,
  type AhaEditorV2Controller,
  type EditorPlugin,
  type AhaEditor,
} from '@aha-app/aha-editor-v2';
import SetEditorControllerPlugin from '../plugins/SetEditorController/SetEditorControllerPlugin';

class AttachmentsController extends ApplicationController {
  $wrapper: JQuery<Element>;
  editorController: AhaEditorV2Controller;
  plugins: EditorPlugin[] = [];

  async initialize() {
    this.initializePlugins();

    // init with empty wrapper
    this.$wrapper = $();
  }

  actionSetContainer(container: HTMLElement): void {
    if (!container) {
      console.warn(
        "[AttachmentsController] No container provided, removing attachments from the editor won't work."
      );
      return;
    }

    const wrapper = container.closest('.aha-editor-field__wrapper');
    if (!wrapper) {
      console.warn(
        "[AttachmentsController] No wrapper found, removing attachments from the editor won't work."
      );
      return;
    }

    this.$wrapper = $(wrapper);

    this.initializeDeletionEvents();
  }

  initializePlugins() {
    this.plugins = [
      SetEditorControllerPlugin({
        setController: controller => {
          this.editorController = controller;
        },
      }),
    ];
  }

  get ahaEditor(): AhaEditor | undefined {
    return this.editorController?.ahaEditor;
  }

  private initializeDeletionEvents(): void {
    this.$wrapper.on('deleteattachment', (_event, attachmentId) => {
      const ahaEditor = this.ahaEditor;
      if (!ahaEditor) return;

      const { editor } = ahaEditor;
      AhaEditorUtils.Attachments.removeBySrc(
        editor,
        this.partialAttachmentUrl(attachmentId)
      );
    });
  }

  private partialAttachmentUrl(attachmentId) {
    return `${window.location.origin}/attachments/${attachmentId}`;
  }

  destroy(): void {
    this.unbindDeletionEvents();
  }

  private unbindDeletionEvents(): void {
    this.$wrapper.off('deleteattachment');
  }
}

export default AttachmentsController;
